/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { type PropsWithChildren, type FC } from 'react';
import { BreadcrumbManager } from '@jira/platform__breadcrumbs/src/breadcrumb-manager/index.tsx';
import { LayoutManager } from '@jira/platform__controllers-layout/src/controllers/layout-controller/containers/layout-manager/LayoutManager.tsx';
import { ClientUiManagers as ClientUiManagersComponent } from './client-ui-managers/index.tsx';
import type { UiManagersProps } from './types.tsx';

const Filler: FC<{ for: string }> = () => null;
const Nest = ({ children }: PropsWithChildren) => <>{children}</>;

const ClientManagerServerVersion = ({ children }: PropsWithChildren) => (
	<Nest>
		<Nest>
			<Filler for="SpotLightMaanger" />
			<Nest>
				<Nest>
					{children}
					<Filler for="ModalContextProvider" />
				</Nest>
				<Filler for="FlagsProvider" />
			</Nest>
		</Nest>
		<Filler for="CrossFlowProvider" />
	</Nest>
);

/**
 * If your component or data provider is not being used inside SSR,
 * put it into `NonCriticalUiManager`, only browser will run those
 * code.
 */
export const UiManagers = ({ children }: UiManagersProps): React.JSX.Element => {
	const ClientUiManagers = !__SERVER__ ? ClientUiManagersComponent : ClientManagerServerVersion;

	return (
		<LayoutManager>
			<BreadcrumbManager>
				<ClientUiManagers>{children}</ClientUiManagers>
			</BreadcrumbManager>
		</LayoutManager>
	);
};
